<template>
  <Card class="card-board__item case-card-item sehatty d-flex flex-column justify-content-between" @click="gotoDonateCase(product.id, close)" data-cy="awqaaf-product-card">
    <template #header>
      <div class="position-relative">
        <VLazyImage loading="lazy" class="condition-img"
             :src="product.product_image"
             alt="صورة الحالة" data-cy="case-image" width="300" height="150"/>
             <div :class="{ 'overlay position-absolute bg-black': product.has_target && calculatePercentage >= 100 }"></div>
        
        <div v-if="product.remaining_period" data-cy="remaining-period"
          class="remaining-period px-3 py-1 position-absolute d-flex align-items-center justify-content-center opacity-50 bg-black rounded-5 text-white">
          <div class="pi pi-clock px-2"></div>
          <div class="pb-1">تنتهي بعد {{product.remaining_period}} يوم</div>
        </div>
      </div>
      <div class="remaining_amount_card" v-if="product.has_target">
        <div v-if="calculatePercentage >= 100" class="d-flex justify-content-center align-items-center p-3 color-primary">
          <div class="completed-icon"></div>
          <div class="">بعطائكم اكتملت فرصة التبرع</div>
        </div>
        <div v-else :class="appendSehattyClass('percentage-card pointer')" data-cy="remaining-amount-value">
          <span class="d-flex align-items-center remaining-amount-text">المتبقي {{ (product.target_amount - product.collected_amount).toLocaleString("en-US") }} <div class="sar-icon mx-1" /></span>
          <div :class="appendSehattyClass('progress mt-1')" data-cy="remaining-amount-progress-bar">
            <div :class="appendSehattyClass('progress-bar') + ' awqaaf-progress-bar'" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                 :style="{width: calculatePercentage <= 100 ? calculatePercentage + '%' : '100%'}"
                 aria-valuemax="100" aria-label="completed ratio">
              <span v-if="calculatePercentage >= 20" class="progress-bar__percentage">{{calculatePercentage <= 100 ? calculatePercentage + '%' : '100%'}}</span>
            </div>
            <div :class="appendSehattyClass('hint')" style="right: 9%">
              {{ Math.trunc((product.collected_amount / product.target_amount) * 100) }}%
            </div>
          </div>
        </div>

      </div>
    </template>
    <template #content>
      <div class="px-3" :class="{'d-flex flex-column justify-content-center h-100': !product.has_target, 'mt-3': product.has_target}">
        <div class="row w-100">
         <div class="fw-bold title" :title="product.title" data-cy="case-title">
            {{ product.title }}
          </div>
          <div class="condition-description mt-2 mb-3" :title="product.short_description" data-cy="case-description">
            {{ product.short_description }}
          </div>
        </div>
      </div>
    </template>
    <template #footer>

      <div class="cta d-flex justify-content-between pt-4">
        <template v-if="product.can_donate !== false && canDonate" class="w-100">
          <Button class="p-button-primary w-100 close-btn"
                  :label="'اقفل الحالة'"
                  :disabled="product.can_donate === false || !canDonate"
                  data-cy="case-closed-button"
                  icon="pi pi-check-circle" v-if="close" 
                  @click="gotoDonateCase(product.id, close)"
          />

          <Button :class="appendSehattyClass('p-button-primary w-100') + ' awqaaf-donate-btn'"
                  :label="'تبرع الآن'"
                  :disabled="product.can_donate === false || !canDonate"
                  data-cy="donate-now-button"
                  @click="gotoDonateCase(product.id, close)"
                  v-if="!close" />
        </template>
        <span v-else-if="calculatePercentage >= 100" class="d-flex align-items-center justify-content-center w-100">
          مكتملة
        </span>
        <span v-else class="d-flex align-items-center justify-content-center w-100">
          تبرع الآن
        </span>
        <DonorCaseShareIcon
          class="me-3 h-100"
          :sharable-link="sharableLink"
          :facebook-link="facebookLink"
          :twitter-link="twitterLink"
          :whatsapp-link="whatsappLink"
          :is-generating-link="isGeneratingLink"
          header="ساهم في العلاج عن طريق مشاركتك الحالة للآخرين"
          :authenticated="!$store.getters.isAuthenticated"
          :variant="isSehattyPage? 'sehatty': 'legacy'"
          :is-endowment-mode="isEndowmentMode"
          aria-label="share case"
          @open="openShareDialog"
        />
      </div>
    </template>
  </Card>
</template>

<script>
import DonorCaseShareIcon from '@/components/campaigns/DonorCaseShareIcon';
import BaseSpinner from "@/components/layout/BaseSpinner.vue";
import JwtUtilService from "@/services/jwt.util.service";
import AmbassadorService from "@/services/ambassador.service";
import WaqfService from "@/services/waqf.service";
import VLazyImage from "v-lazy-image";
import { setLocalValue } from "@/hooks/useLocalStorage"
import { useRouter } from 'vue-router';
import { appendSehattyClass, getDomainWithoutProtocol } from '@/helpers/helpers';

export default {
  name: "AwqaafProductCard",
  inject: ['staticUrl'],
  components: { BaseSpinner, VLazyImage, DonorCaseShareIcon },
  props: {
    product: {
      type: Object,
      required: true
    },
    close: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      sharableLink: "",
      isGeneratingLink: false,
      canDonate: JwtUtilService.getClientID()?.includes("doner") || JwtUtilService.getClientID()?.includes("major-donor") || !this.$store.getters.isAuthenticated,
      canShareTrackableLink: JwtUtilService.getClientID()?.includes("doner") && this.$store.getters.isAuthenticated,
      PREVIEWURL: process.env.VUE_APP_API_URL+'/share',
      loading: false,
      facebookLink: "",
      twitterLink: "",
      whatsappLink: "",
      isSehattyPage: this.$store.getters.isSehattyPage,
      router: useRouter(),
      isEndowmentMode: false
    };
  },
  mounted() {
    this.addRemainingPeriod();
    this.isEndowmentMode = this.$route.query.mode === 'endowments';
  },
  watch: {
    product(val) {
      if (val) {
        this.addRemainingPeriod();
        this.sharableLink = `https://${getDomainWithoutProtocol()}/c/${val.id}`;
      }
    },
  },
  methods: {
    appendSehattyClass,
    async openShareDialog() {
      this.isGeneratingLink = true;
      try {
        const response = await WaqfService.getShareLinks(this.product?.id);
        const result = response.data.result;
        let finalLink = result.share_urls.copy_link;
        this.facebookLink = result.share_urls.facebook;
        this.twitterLink = result.share_urls.twitter;
        this.whatsappLink = result.share_urls.whatsapp;

        if (this.canShareTrackableLink) {
            const ambassadorResponse = await AmbassadorService.postHefWaqfProductNumber({hef_waqf_product: this.product?.id});
            const ambassadorResult = ambassadorResponse.data.result;
            if (ambassadorResult && ambassadorResult.id) {
                finalLink = finalLink.endsWith('/')
                    ? `${finalLink}${ambassadorResult.id}`
                    : `${finalLink}/${ambassadorResult.id}`;
            }
        }
        this.sharableLink = finalLink;
      } catch (error) {
        console.error(error);
      } finally {
        this.isGeneratingLink = false;
      }
    },
    async createLink() {
      this.isGeneratingLink = true;
      await AmbassadorService.postCaseNumber({case: this.product?.id}).then((response) => {
        const result = response.data.result;
        const domain = `https://${getDomainWithoutProtocol()}`;
        this.sharableLink = `${domain}/c/${result.case}/${result.id}`;
      }).finally(() => {
        this.isGeneratingLink = false;
      });
    },
    addRemainingPeriod() {
      if (!this.product?.published_on) return;
      let caseEndDate = new Date(this.product.published_on).setDate(new Date(this.product.published_on).getDate() + this.product.publish_duration);
      let remaining_period_in_days = Math.ceil((new Date(caseEndDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
      this.product.remaining_period = remaining_period_in_days > 0 ? remaining_period_in_days : 0;
    },
    gotoDonateCase(id, close) {
      if (!this.canDonate) return;
      setLocalValue('selected_case_id', this.product.id);
      let url = `/donate-hef-waqf/${id}`;
      const queryParams = [];
      if (close) {
        queryParams.push('close=true');
      }
      if (this.isSehattyPage) {
        queryParams.push('sehatty=true');
      }
      if (this.$route.query.mode === 'endowments') {
        queryParams.push('mode=endowments');
      }
      if (queryParams.length > 0) {
        url += '?' + queryParams.join('&');
      }
      window.location.href = url;
    }
  },
  computed: {
    calculatePercentage() {
      return Math.trunc((this.product.collected_amount / this.product.target_amount) * 100);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/components/case-card";
@import "@/styles/components/riyal-logo";

::v-deep(.p-card-footer) {
  padding: 0  0 20px !important;
}

.overlay {
  inset: 0;
  opacity: 1;
  mix-blend-mode: color;
}

.completed-icon {
  width: 41px;
  height: 45px;
  background-image: url(#{$static-url}/static/icons/completedicon.svg);
}

.remaining_amount_card {
  font-size: 14px;
  width: 90%;
}

.condition-description{
  text-align: justify;
}

.remaining-amount-text {
  color: $color-awqaaf-product-amount !important;
}

.awqaaf-progress-bar {
  background: linear-gradient(270deg, $color-awqaaf-product-progress-light 0%, $color-awqaaf-product-progress-dark 100%) !important;
}

::v-deep(.awqaaf-donate-btn) {
    background-color: $color-awqaaf-product-btn-bg !important;
    border-color: $color-awqaaf-product-btn-bg !important;
    
    .p-button-label {
        color: $color-awqaaf-product-btn-text !important;
        font-weight: bold;
    }
    
    &:hover {
         background-color: darken($color-awqaaf-product-btn-bg, 5%) !important;
         border-color: darken($color-awqaaf-product-btn-bg, 5%) !important;
    }
}
</style>
